import { useState } from 'react';
import { Button, Paper } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { columns } from './grid-columns';
import { SkillSetForm } from './skill-set.form';
import { SkillSet } from '../../../models/masters/skill-set';
import { skillSetFormSchema } from './skill-set-form.schema';
import { SiTrackGrid } from '../../../components/si-track-grid/si-track-grid';
import { SaveHookFormDialog } from '../../../components/save-hook-form.dialog';
import { skillSetApiKeyStore } from '../../../api/masters/skill-set-api-key-store';
import { SiTrackPage } from '../../../components/si-track-page';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';

const styling = {
  paperStyle: { padding: '20px', borderRadius: '20px' },
};

export const SkillSetPage = () => {
  const [editItem, setEditItem] = useState<Partial<SkillSet>>();

  const handleEditSkillSet = (skillSet: SkillSet) => {
    setEditItem(skillSet);
  };

  const handleEditClose = () => {
    setEditItem(undefined);
  };

  const handleCreateSkillSet = () => {
    setEditItem({});
  };

  return (
    <SiTrackPage
      title="Skill Set"
      actionButton={
        <GuardedComponent requiredPermissions={[UserPermissionName.ADD_SKILLSET]}>
          <Button
            size="small"
            variant="contained"
            disableElevation={true}
            startIcon={<AddIcon />}
            onClick={handleCreateSkillSet}
          >
            Add Skill Set
          </Button>
        </GuardedComponent>
      }
    >
      <Paper elevation={0} style={styling.paperStyle}>
        <SiTrackGrid
          fileTitle='skill_set'
          dataItemKey="skillsetID"
          columns={columns}
          queryConfig={skillSetApiKeyStore.getSkillSets()}
          onEdit={handleEditSkillSet}
          actionPermissions={{
            edit: UserPermissionName.EDIT_SKILLSET,
            delete: UserPermissionName.DELETE_SKILLSET,
            export: UserPermissionName.DOWNLOAD_GRID,
          }}
        />
        {editItem && (
          <SaveHookFormDialog
            title={editItem.skillsetID ? 'UPDATE SKILL SET' : 'CREATE SKILL SET'}
            config={{
              saveConfig: editItem.skillsetID
                ? skillSetApiKeyStore.updateSkillSet()
                : skillSetApiKeyStore.createSkillSet(),
              invalidateRoute: () => skillSetApiKeyStore.getSkillSets(),
            }}
            data={editItem}
            yupSchema={skillSetFormSchema}
            onClose={handleEditClose}
            size="xs"
          >
            <SkillSetForm skillsetID={editItem.skillsetID} />
          </SaveHookFormDialog>
        )}
      </Paper>
    </SiTrackPage>
  );
};
